/**
 * Houses all the Ids assigned to the specific elements of this application DOM.
 */
class ElementIds {
    static appId: string = 'app-element-id';
}

export default ElementIds;
